export default __webpack_public_path__ + "static/media/icon-up.6f53e43e.svg";